import { render, staticRenderFns } from "./StagePlaatsen.vue?vue&type=template&id=3f6f3162&"
import script from "./StagePlaatsen.vue?vue&type=script&lang=js&"
export * from "./StagePlaatsen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StagePlaatsen.vue"
export default component.exports